/**
 * Paths relative to the axios client `baseURL` (`${API_URL}/api`), matching the
 * backend global prefix. Browser OAuth redirect uses `/api/auth/google` on the API host.
 */
export const apiPaths = {
  auth: {
    logout: "/auth/logout",
    /** Segment after `/api` for login redirect (`GET /api/auth/google`). */
    google: "/auth/google",
  },
  users: {
    me: "/users/me",
  },
  projects: {
    list: "/projects",
    one: (id: string) => `/projects/${id}`,
    apiKeys: (projectId: string) => `/projects/${projectId}/api-keys`,
    apiKey: (projectId: string, keyId: string) =>
      `/projects/${projectId}/api-keys/${keyId}`,
    metrics: (projectId: string) => `/projects/${projectId}/metrics`,
  },
  metrics: {
    list: "/metrics",
    one: (id: string) => `/metrics/${id}`,
  },
  requests: {
    list: "/requests",
    /** Declared before `GET /requests` on the backend so `stats` is not parsed as an id. */
    stats: "/requests/stats",
  },
} as const;
